import React, { useEffect } from 'react';

import { useSessionData } from '@confluence/session-data';

import { useEditorAIFeedbackCollector } from '../hooks';
import type { EditorPluginAIFeedbackHandlersRef } from '../hooks/useEditorPluginAIFeedbackHandlers';

interface EditorPluginAIWithFeedbackProps {
	editorPluginAIFeedbackHandlers: React.RefObject<EditorPluginAIFeedbackHandlersRef>;
}

export const EditorPluginAIWithFeedback: React.FC<EditorPluginAIWithFeedbackProps> = ({
	editorPluginAIFeedbackHandlers,
}) => {
	const { cloudId } = useSessionData();

	const { FeedbackCollector, openFeedbackCollector } = useEditorAIFeedbackCollector();

	useEffect(() => {
		if (editorPluginAIFeedbackHandlers.current) {
			editorPluginAIFeedbackHandlers.current.handleFeedbackClicked = openFeedbackCollector;
		}
	}, [editorPluginAIFeedbackHandlers, cloudId, openFeedbackCollector]);

	return <FeedbackCollector />;
};
